import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from 'firebase/auth';

import { databaseConfig } from './config/database';

const DEFAULT_FIREBASE_CONFIG = {
  apiKey: 'AIzaSyCmmN_P_jj_aO1vQhvCtzBT-K8ZmHj5r1g',
  authDomain: 'crm-teleworker.firebaseapp.com',
  projectId: 'crm-teleworker',
  storageBucket: 'crm-teleworker.firebasestorage.app',
  messagingSenderId: '574240927146',
  appId: '1:574240927146:web:9e0e91f328c32563090fd3',
  measurementId: 'G-3SMGTKZGY7'
};

// 優先使用環境變數，其次使用 databaseConfig，最後使用預設值
// 注意：React 環境變數需要在構建時注入，如果環境變數未載入，會使用預設值
const firebaseConfig = {
  apiKey:
    (process.env.REACT_APP_FIREBASE_API_KEY && process.env.REACT_APP_FIREBASE_API_KEY.trim()) ||
    (databaseConfig.firebase.apiKey && databaseConfig.firebase.apiKey.trim()) ||
    DEFAULT_FIREBASE_CONFIG.apiKey,
  authDomain:
    (process.env.REACT_APP_FIREBASE_AUTH_DOMAIN && process.env.REACT_APP_FIREBASE_AUTH_DOMAIN.trim()) ||
    (databaseConfig.firebase.authDomain && databaseConfig.firebase.authDomain.trim()) ||
    DEFAULT_FIREBASE_CONFIG.authDomain,
  projectId:
    (process.env.REACT_APP_FIREBASE_PROJECT_ID && process.env.REACT_APP_FIREBASE_PROJECT_ID.trim()) ||
    (databaseConfig.firebase.projectId && databaseConfig.firebase.projectId.trim()) ||
    DEFAULT_FIREBASE_CONFIG.projectId,
  storageBucket:
    (process.env.REACT_APP_FIREBASE_STORAGE_BUCKET && process.env.REACT_APP_FIREBASE_STORAGE_BUCKET.trim()) ||
    (databaseConfig.firebase.storageBucket && databaseConfig.firebase.storageBucket.trim()) ||
    DEFAULT_FIREBASE_CONFIG.storageBucket,
  messagingSenderId:
    (process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID && process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID.trim()) ||
    (databaseConfig.firebase.messagingSenderId && databaseConfig.firebase.messagingSenderId.trim()) ||
    DEFAULT_FIREBASE_CONFIG.messagingSenderId,
  appId:
    (process.env.REACT_APP_FIREBASE_APP_ID && process.env.REACT_APP_FIREBASE_APP_ID.trim()) ||
    (databaseConfig.firebase.appId && databaseConfig.firebase.appId.trim()) ||
    DEFAULT_FIREBASE_CONFIG.appId
};

const missingConfigKeys = Object.entries(firebaseConfig)
  .filter(([, value]) => !value)
  .map(([key]) => key);

if (missingConfigKeys.length > 0) {
  // eslint-disable-next-line no-console
  console.error('[Firebase] 缺少必要的環境變數設定：', missingConfigKeys.join(', '));
}

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);

// 設置認證狀態持久性為 LOCAL（使用 localStorage）
// 這確保用戶登入狀態在瀏覽器關閉後仍然保持
setPersistence(auth, browserLocalPersistence).catch((error) => {
  // eslint-disable-next-line no-console
  console.error('❌ 設置認證持久性失敗:', error);
});

export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

export const storageConfig = {
  maxUploadSize: 20 * 1024 * 1024, // 20MB
  maxConcurrentUploads: 3,
  retryMaxAttempts: 3,
  retryDelayMs: 1000
};